<template>
    <div @click="connectProvider" class="monitor-box add-monitor">
        <div class="action-container">
            <p>This account is not connected to a DigitalOcean account.</p>
            <p style="text-align:center;padding-top:20px;">
                <font-awesome-icon icon="plus-circle"/>
                <span>{{ connectText }}</span>
            </p>
        </div>
    </div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';

export default {
    props: ['account'],

    data() {
        return {
            connecting: false,
        }
    },

    methods: {
        connectProvider() {
            if (this.connecting) {
                return;
            }

            localStorage.accountPendingAssociation = JSON.stringify({
               id: this.account.id,
            });

            this.connecting = true;
            window.location.href = this.account.authorization_url;
        },
    },

    computed: {
        connectText() {
            if (this.connecting) {
                return 'Connecting...';
            }
            return 'Connect now';
        },
    },
}
</script>
